function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.842 6.587a4.1 4.1 0 001.721-2.284 7.596 7.596 0 01-2.488 1.002A3.813 3.813 0 0015.217 4c-2.163 0-3.915 1.85-3.915 4.13 0 .324.032.64.1.941-3.255-.172-6.14-1.815-8.073-4.316a4.294 4.294 0 00-.53 2.078c0 1.432.691 2.697 1.742 3.439a3.777 3.777 0 01-1.775-.516v.05c0 2.002 1.35 3.672 3.144 4.05-.33.097-.675.146-1.034.146-.252 0-.498-.025-.736-.073.498 1.64 1.944 2.836 3.659 2.868A7.604 7.604 0 012 18.508a10.68 10.68 0 006.004 1.856c7.205 0 11.143-6.295 11.143-11.754 0-.18-.002-.358-.01-.534a8.187 8.187 0 001.954-2.139 7.507 7.507 0 01-2.249.65z"
  }));
};
SvgTwitter.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgTwitter.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgTwitter;